import {
  createSelectOptionColorPicker,
  SELECT_OPTION_COLORS,
  type SelectOptionColor,
} from '@streamlain/database-identity';

export type { SelectOptionColor };

export const selectOptionColors: SelectOptionColor[] = [
  ...SELECT_OPTION_COLORS,
];

export const getTagColor = createSelectOptionColorPicker();
